import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../button/button'
import Logo from '../../../images/icon512-gray.png'

const HomeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-color: #90d1a8;
  // background-color: #333;
  text-align: center;
`

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 40px;
  color: #333;
  font-weight: bold;
  margin-block-start: 32.16px;
  margin-block-end: 40px;
  // color: #90d1a8;
`

const ButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
`

// const StyledButton = styled(Button)`
//   width: 200px;
//   padding: 10px;
//   font-size: 1.2rem;
//   background-color: #90d1a8;
//   // color: white;
//   color: #333;
//   border-color: #333;
//   // border: 1px solid #333;
//   text-decoration: none;
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 5px;
//   cursor: pointer;
//   transition: background-color 0.3s;

//   // &:hover {
//   //   background-color: #78b08f;
//   // }
// `

const Home = () => {
  const title = 'WordGrid.io'

  return (
    <HomeContainer>
      <img width={64} src={Logo} />  
      <Title>{title}</Title>
      <ButtonBox>
        <Button text='New Game' to='/game/new' />
        <Button text='Continue' to='/game/continue' />
        <Button text='Settings' to='/settings' />
        <Button text='Feedback' to='/feedback' />
      </ButtonBox>
    </HomeContainer>
  )
}

export default Home
